import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import BackToTop from '@/components/feature/BackToTop';
import PageMeta from '@/components/base/PageMeta';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function AboutPage() {
  const { t } = useTranslation();

  const testimonials = [
    {
      name: '小明',
      role: '漫画爱好者',
      content: '抖漫网页版真的是太方便了！不用下载APP，电脑手机都能看，而且更新速度超快，每天都忍不住刷好几次。',
      rating: 5,
    },
    {
      name: '花花',
      role: '大学生',
      content: '课间休息的时候就用手机浏览器打开抖漫看两话，画质清晰、加载很快，推荐了很多同学一起用。',
      rating: 5,
    },
    {
      name: '老张',
      role: '上班族',
      content: '通勤路上最喜欢看抖漫，资源丰富种类齐全，想看的漫画基本都能找到，而且完全免费，太良心了。',
      rating: 4,
    },
    {
      name: '小丽',
      role: '二次元博主',
      content: '作为漫画博主，抖漫网页版是我日常追更的首选平台。更新及时、阅读流畅，强烈推荐给所有漫画迷。',
      rating: 5,
    },
    {
      name: '阿杰',
      role: '自由职业者',
      content: '之前一直用APP看漫画，换了抖漫网页版后发现网页版体验完全不输APP，而且省了手机内存，完美。',
      rating: 5,
    },
    {
      name: '小萌',
      role: '高中生',
      content: '最喜欢抖漫的分类功能，按照热血、恋爱、悬疑分类找漫画特别方便，总能找到喜欢的作品。',
      rating: 4,
    },
  ];

  const stats = [
    { value: '500万+', label: t('about.stats_users') },
    { value: '3000+', label: t('about.stats_comics') },
    { value: '10亿+', label: t('about.stats_views') },
    { value: '100万+', label: t('about.stats_daily') },
  ];

  return (
    <>
      <ScrollToTop />
      <PageMeta
        title="关于我们 - 抖漫网页版 | 品牌故事 · 用户口碑 · 联系方式"
        description="了解抖漫网页版的品牌故事与发展历程。抖漫网页版成立于2020年，专注为漫画爱好者提供优质免费的在线漫画阅读体验，覆盖500万+用户，收录3000+部优质漫画。"
        keywords="抖漫网页版,关于抖漫,漫画平台介绍,联系我们,免费漫画"
        canonicalUrl="https://douman.readdy.ai/about"
        ogType="article"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          name: '关于抖漫网页版',
          description: '了解抖漫网页版的品牌故事、用户口碑与联系方式。',
          url: 'https://douman.readdy.ai/about',
          isPartOf: {
            '@type': 'WebSite',
            name: '抖漫网页版',
            url: 'https://douman.readdy.ai',
          },
          breadcrumb: {
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://douman.readdy.ai' },
              { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://douman.readdy.ai/about' },
            ],
          },
        }}
      />
      <Navbar />
      <main className="pt-16">
        <section className="py-10 md:py-14 px-4 md:px-6">
          <div className="max-w-5xl mx-auto">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors">{t('article.breadcrumb_home')}</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-950 font-medium">{t('about.title')}</span>
            </nav>

            <div className="text-center mb-12">
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                {t('about.title')}
              </h1>
              <p className="text-sm text-foreground-600 max-w-lg mx-auto">{t('about.subtitle')}</p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-14">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center p-4 rounded-xl bg-background-100/70">
                  <div className="text-2xl md:text-3xl font-bold text-primary-500 mb-1" style={{ fontFamily: 'var(--font-heading)' }}>
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-14">
              <div>
                <h2 className="text-xl font-bold text-foreground-950 mb-4 flex items-center gap-2" style={{ fontFamily: 'var(--font-heading)' }}>
                  <i className="ri-bookmark-line text-primary-500"></i>
                  {t('about.brand_title')}
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">{t('about.brand_content')}</p>
              </div>
              <div>
                <h2 className="text-xl font-bold text-foreground-950 mb-4 flex items-center gap-2" style={{ fontFamily: 'var(--font-heading)' }}>
                  <i className="ri-focus-2-line text-accent-500"></i>
                  {t('about.mission_title')}
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {t('about.mission_content')}
                </p>
              </div>
            </div>

            <div className="mb-14">
              <h2 className="text-xl font-bold text-foreground-950 mb-6 text-center" style={{ fontFamily: 'var(--font-heading)' }}>
                <i className="ri-heart-line text-primary-500 mr-2"></i>
                {t('about.reputation_title')}
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {testimonials.map((item, idx) => (
                  <div key={idx} className="p-5 rounded-xl bg-background-100/70">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: 5 }, (_, i) => (
                        <i
                          key={i}
                          className={`text-xs ${i < item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                        ></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">&ldquo;{item.content}&rdquo;</p>
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center text-primary-500 text-xs font-bold">
                        {item.name[0]}
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-950">{item.name}</div>
                        <div className="text-xs text-foreground-500">{item.role}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h2 className="text-xl font-bold text-foreground-950 mb-6 text-center" style={{ fontFamily: 'var(--font-heading)' }}>
                <i className="ri-send-plane-line text-secondary-500 mr-2"></i>
                {t('about.contact_title')}
              </h2>
              <p className="text-sm text-foreground-600 text-center mb-8">{t('about.contact_subtitle')}</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                <div className="p-5 rounded-xl bg-background-100/70 text-center">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                    <i className="ri-map-pin-line"></i>
                  </div>
                  <h4 className="text-sm font-semibold text-foreground-950 mb-1">{t('about.address')}</h4>
                  <p className="text-xs text-foreground-500">{t('about.address_value')}</p>
                </div>
                <div className="p-5 rounded-xl bg-background-100/70 text-center">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-500">
                    <i className="ri-mail-line"></i>
                  </div>
                  <h4 className="text-sm font-semibold text-foreground-950 mb-1">{t('about.email')}</h4>
                  <p className="text-xs text-foreground-500">{t('about.email_value')}</p>
                </div>
                <div className="p-5 rounded-xl bg-background-100/70 text-center">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500">
                    <i className="ri-phone-line"></i>
                  </div>
                  <h4 className="text-sm font-semibold text-foreground-950 mb-1">{t('about.phone')}</h4>
                  <p className="text-xs text-foreground-500">{t('about.phone_value')}</p>
                </div>
                <div className="p-5 rounded-xl bg-background-100/70 text-center">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                    <i className="ri-time-line"></i>
                  </div>
                  <h4 className="text-sm font-semibold text-foreground-950 mb-1">{t('about.business_hours')}</h4>
                  <p className="text-xs text-foreground-500">{t('about.business_hours_value')}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}